module.exports = __webpack_public_path__ + "img/card_v3.c99e1b8.png";